import { SkeletonText } from "@core/components/SkeletonText";
import type { SupportingTextVariant } from "@core/components/SupportingText";
import { SupportingText } from "@core/components/SupportingText";
import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";

import styles from "./PasswordRequirements.module.scss";

export type PasswordRequirement = {
  label: string;
  isMet: boolean;
};

export type PasswordRequirementsProps = {
  requirements: PasswordRequirement[];
  pending?: boolean;
} & SafeHtmlAttributes;

const getVariant = (isMet: boolean): SupportingTextVariant => (isMet ? "success" : "info");

const SKELETON_ROWS = 4;

export const PasswordRequirements = ({ requirements, pending = false, ...rest }: PasswordRequirementsProps) => {
  if (pending) {
    return (
      <div {...rest} className={styles.root} aria-busy="true">
        <SkeletonText rows={SKELETON_ROWS} />
      </div>
    );
  }

  if (requirements.length === 0) return null;

  return (
    <ul {...rest} className={styles.root}>
      {requirements.map((requirement) => (
        <li key={requirement.label} className={styles.item}>
          <SupportingText variant={getVariant(requirement.isMet)}>{requirement.label}</SupportingText>
        </li>
      ))}
    </ul>
  );
};
